"use strict";

const breakpoints = {
    xs: 0,
    sm: 544,
    md: 768,
    lg: 992,
    xl: 1440
};

module.exports = { breakpoints };
